<template>
  <div>
    <b-card title="Device">
      <hr>
      <b-row
        xl="12"
        sm="12"
      >
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
          style="display: none;"
        >
          <v-select
            id="v-Province"
            v-model="select_6"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="ProvinceOptions"
            :reduce="ProvinceOptions => ProvinceOptions.value"
            label="title"
            placeholder="--Select Province --"
            class="w-100"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
          style="display: none;"
        >
          <v-select
            id="v-Regency"
            v-model="select_7"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="RegencyOptions"
            :reduce="RegencyOptions => RegencyOptions.value"
            label="title"
            placeholder="--Select Regency --"
            class="w-100"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
          style="display: none;"
        >
          <v-select
            id="v-District"
            v-model="select_8"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="DistrictOptions"
            :reduce="DistrictOptions => DistrictOptions.value"
            label="title"
            placeholder="--Select District --"
            class="w-100"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <v-select
            v-model="select_site"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="SiteOptions"
            :reduce="SiteOptions => SiteOptions.value"
            label="title"
            placeholder="Site"
            class="w-100"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <v-select
            v-model="select_device"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="DeviceOptions"
            :reduce="DeviceOptions => DeviceOptions.value"
            label="title"
            placeholder="Device"
            class="w-100"
            @input="changeDate()"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-card title="Filter">
      <hr>
      <b-row
        xl="12"
        sm="12"
      >
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <v-select
            v-model="statusFilter_Temperature"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :options="statusOptions"
            :reduce="statusOptions => statusOptions.value"
            class="w-100"
            @input="changeDate()"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
          :hidden="statusFilter_Temperature === 'A'"
        >
          <b-input-group>
            <flat-pickr
              v-model="date_start"
              class="form-control"
              :config="{ enableTime: false, time_24hr: false, }"
              placeholder="DD-MM-YYYY"
              :disabled="statusFilter_Temperature === 'A'"
              @input="changeDate()"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="CalendarIcon"
                class="cursor-pointer"
              />
              <b>&nbsp;Start</b>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
          :hidden="statusFilter_Temperature === 'A'"
        >
          <b-input-group>
            <flat-pickr
              v-model="date_finish"
              class="form-control"
              :config="{ enableTime: false, time_24hr: false, }"
              placeholder="DD-MM-YYYY"
              :disabled="statusFilter_Temperature === 'A'"
              @input="changeDate()"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="ClockIcon"
                class="cursor-pointer"
              />
              <b>&nbsp;Finish</b>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            class="sidebar-center"
            variant="outline-primary"
            @click="changeDate()"
          >
            <feather-icon icon="SearchIcon" /> Filter
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <!-- <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    > -->
    <b-card title="Trend">
      <hr>
      <b-row>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <br>
          <br>
          <br>
          <!-- apex chart -->
          <!-- <vue-apex-charts
              type="radialBar"
              height="245"
              class="my-2"
              :options="goalOverviewRadialBarTemperature"
              :series="[valueToPercent(this.realtime_sparing.value, this.realtime_sparing.value_min, this.realtime_sparing.value_max)]"
            /> -->
          <vue-apex-charts
            type="radialBar"
            height="245"
            class="my-2"
            :options="goalOverviewRadialBarTemperature"
            :series="series"
          />
          <b-row class="text-center mx-0">
            <b-col
              cols="6"
              class="border-top border-right d-flex align-items-between flex-column py-1"
            >
              <h3 class="font-weight-bolder mb-0">
                {{ this.realtime_sparing.value_min }} {{ this.realtime_sparing.value_default_unit }}
              </h3>
            </b-col>

            <b-col
              cols="6"
              class="border-top d-flex align-items-between flex-column py-1"
            >
              <h3 class="font-weight-bolder mb-0">
                {{ this.realtime_sparing.value_max }} {{ this.realtime_sparing.value_default_unit }}
              </h3>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          md="9"
          class="mb-md-0 mb-2"
        >
          <b-card-body>
            <vue-apex-charts
              type="line"
              height="400"
              :options="lineChartSimpleTemperature.chartOptions"
              :series="lineChartSimpleTemperature.series"
            />
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <div>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="ml-1 mb-1"
          variant="outline-primary"
          @click="exportExcelTemperature"
        >
          <feather-icon icon="DownloadIcon" /> Export
        </b-button>
      </div>
      <div>
        <div class="h-50 d-inline-block" />
      </div>
      <div class="d-flex justify-content-between flex-wrap">
        <!-- sorting  -->
        <b-form-group
          label="Sort"
          label-size="sm"
          label-align-sm="left"
          label-cols-sm="3"
          label-for="sortBySelect"
          class="mr-1"
        >
          <b-input-group size="sm">
            <b-form-select
              id="sortBySelect"
              v-model="sortBy_Temperature"
              :options="sortOptions_Temperature"
            >
              <template #first>
                <option value="">
                  none
                </option>
              </template>
            </b-form-select>
            <b-form-select
              v-model="sortDesc_Temperature"
              size="sm"
              :disabled="!sortBy_Temperature"
            >
              <option :value="false">
                Asc
              </option>
              <option :value="true">
                Desc
              </option>
            </b-form-select>
          </b-input-group>
        </b-form-group>

        <!-- filter -->
        <b-form-group
          label="Filter"
          label-cols-sm="2"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mr-1"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter_Temperature"
              type="search"
              placeholder="Type to Search"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter_Temperature"
                @click="filter_Temperature = ''"
              >
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <b-table
        striped
        hover
        responsive
        class="position-relative"
        :per-page="perPage_Temperature"
        :current-page="currentPage_Temperature"
        :items="historical_temperature"
        :fields="fields_Temperature"
        :sort-by.sync="sortBy_Temperature"
        :sort-desc.sync="sortDesc_Temperature"
        :sort-direction="sortDirection_Temperature"
        :filter="filter_Temperature"
        :filter-included-fields="filterOn_Temperature"
        @filtered="onFiltered_Temperature"
      >
        <template #cell(datetime)="data">
          {{ dateFormat(data.value) }}
        </template>
        <template #cell(actual_date)="data">
          {{ dateFormat(data.value) }}
        </template>
        <template #cell(value)="row">
          {{ row.item.value }}
        </template>
        <template #cell(status)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="6"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage_Temperature"
            size="sm"
            inline
            :options="pageOptions_Temperature"
          />
        </b-form-group>
        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage_Temperature"
            :total-rows="totalRows_Temperature"
            :per-page="perPage_Temperature"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>
    <b-card
      title="Battery Power"
      style="display: none;"
    >
      <hr>
      <b-row>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <br>
          <br>
          <br>
          <!-- apex chart -->
          <vue-apex-charts
            type="radialBar"
            height="245"
            class="my-2"
            :options="goalOverviewRadialBarBattery"
            :series="[this.realtime_battery.value]"
          />
          <b-row class="text-center mx-0">
            <!-- <b-col
            cols="6"
            class="border-top border-right d-flex align-items-between flex-column py-1"
          >
            <h3 class="font-weight-bolder mb-0">
            </h3>
          </b-col>

          <b-col
            cols="6"
            class="border-top d-flex align-items-between flex-column py-1"
          >
            <h3 class="font-weight-bolder mb-0">
            </h3>
          </b-col> -->
          </b-row>
        </b-col>
        <b-col
          cols="12"
          md="9"
          class="mb-md-0 mb-2"
        >
          <b-card-body>
            <vue-apex-charts
              type="line"
              height="400"
              :options="lineChartSimpleBattery.chartOptions"
              :series="lineChartSimpleBattery.series"
            />
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
    <b-card style="display: none;">
      <div>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="ml-1 mb-1"
          variant="outline-primary"
          @click="exportExcelBattery"
        >
          <feather-icon icon="DownloadIcon" /> Export
        </b-button>
      </div>
      <div>
        <div class="h-50 d-inline-block" />
      </div>
      <div class="d-flex justify-content-between flex-wrap">
        <!-- sorting  -->
        <b-form-group
          label="Sort"
          label-size="sm"
          label-align-sm="left"
          label-cols-sm="3"
          label-for="sortBySelect"
          class="ml-1"
        >
          <b-input-group size="sm">
            <b-form-select
              id="sortBySelect"
              v-model="sortBy_Battery"
              :options="sortOptions_Battery"
            >
              <template #first>
                <option value="">
                  none
                </option>
              </template>
            </b-form-select>
            <b-form-select
              v-model="sortDesc_Battery"
              size="sm"
              :disabled="!sortBy_Battery"
            >
              <option :value="false">
                Asc
              </option>
              <option :value="true">
                Desc
              </option>
            </b-form-select>
          </b-input-group>
        </b-form-group>

        <!-- filter -->
        <b-form-group
          label="Filter"
          label-cols-sm="2"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mr-1"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter_Battery"
              type="search"
              placeholder="Type to Search"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter_Battery"
                @click="filter_Battery = ''"
              >
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <b-table
        striped
        hover
        responsive
        class="position-relative"
        :per-page="perPage_Battery"
        :current-page="currentPage_Battery"
        :items="historical_battery"
        :fields="fields_Battery"
        :sort-by.sync="sortBy_Battery"
        :sort-desc.sync="sortDesc_Battery"
        :sort-direction="sortDirection_Battery"
        :filter="filter_Battery"
        :filter-included-fields="filterOn_Battery"
        @filtered="onFiltered_Battery"
      >
        <template #cell(datetime)="data">
          {{ dateFormat(data.value) }}
        </template>
        <template #cell(value)="row">
          {{ row.item.value + row.item.value_default_unit }}
        </template>
        <template #cell(status)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="6"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage_Battery"
            size="sm"
            inline
            :options="pageOptions_Battery"
          />
        </b-form-group>
        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage_Battery"
            :total-rows="totalRows_Battery"
            :per-page="perPage_Battery"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>
    <!-- </b-overlay> -->
  </div>
</template>
<script>
import {
  BCard, BOverlay, BTable, BImg, BInputGroup, BInputGroupAppend, BCardBody, BLink, BButton, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BRow, BCol, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import useAppConfig from '@core/app-config/useAppConfig'
import flatPickr from 'vue-flatpickr-component'
import { computed, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import { $themeColors } from '@themeConfig'
import XLSX from 'xlsx'
import store from '@/store/index'

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({ name: XLSX.utils.encode_col(i), key: i }))
const _SheetJSFT = ['xlsx', 'xlsb', 'xlsm', 'xls', 'xml', 'csv', 'txt', 'ods', 'fods', 'uos', 'sylk', 'dif', 'dbf', 'prn', 'qpw', '123', 'wb*', 'wq*', 'html', 'htm'].map(x => `.${x}`).join(',')

const $strokeColor = '#ebe9f1'
const $textHeadingColor = '#5e5873'
const $goalStrokeColor2 = '#51e5a8'
// colors
const chartColors = {
  column: {
    series1: '#826af9',
    series2: '#d2b0ff',
    bg: '#f8d3ff',
  },
  success: {
    shade_100: '#7eefc7',
    shade_200: '#06774f',
  },
  donut: {
    series1: '#ffe700',
    series2: '#00d4bd',
    series3: '#826bf8',
    series4: '#2b9bf4',
    series5: '#FFA1A1',
  },
  area: {
    series3: '#a4f8cd',
    series2: '#60f2ca',
    series1: '#2bdac7',
  },
}
export default {
  components: {
    XLSX, vSelect, flatPickr, moment, VueApexCharts, BCard, BOverlay, BTable, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BRow, BCol, BDropdown, BDropdownItem, ToastificationContent,
  },
  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')
    watch(isDark, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        // Memuat ulang halaman saat nilai isDark berubah
        window.location.reload()
      }
    })
    return { skin, isDark }
  },
  data() {
    return {
      goalOverviewRadialBarTemperature: {
        chart: {
          height: 245,
          type: 'radialBar',
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '77%',
            },
            track: {
              background: $strokeColor,
              strokeWidth: '50%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: $textHeadingColor,
                fontSize: '2.86rem',
                fontWeight: '600',
                formatter: val => `${val}°C`,
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: [$themeColors.success],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
      goalOverviewRadialBarBattery: {
        chart: {
          height: 245,
          type: 'radialBar',
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '77%',
            },
            track: {
              background: $strokeColor,
              strokeWidth: '50%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: $textHeadingColor,
                fontSize: '2.86rem',
                fontWeight: '600',
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: [$themeColors.success],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
      lineChartSimpleTemperature: {
        series: [
          {
            name: 'Sparing',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              areas: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
          },
        },
      },
      lineChartSimpleBattery: {
        series: [
          {
            name: 'Battery Power',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            // opposite: isRtl,
          },
        },
      },
      date_start: moment(String(new Date())).format('YYYY-MM-DD'),
      date_finish: moment(String(new Date())).format('YYYY-MM-DD'),
      select_6: '',
      select_7: '',
      select_8: '',
      select_9: '',
      perPage: 20,
      select_device: null,
      show: false,
      dir: false,
      resolutionOptions: [
        { title: '5 Minutes', value: 'five_minutes' },
        { title: '30 Minutes', value: 'thirty_minutes' },
        { title: 'Hourly', value: 'hourly' },
        { title: 'Daily', value: 'daily' },
      ],
      realtime_sparing: {
        value: 0,
        value_default_unit: '°C ',
        value_max: 30,
        value_min: -10,
      },
      realtime_battery: {
        value: null,
        value_default_unit: null,
        value_max: null,
        value_min: null,
      },
      currentPage: 1,
      sortBy_Temperature: '',
      DefaultDevice: '',
      sortDesc_Temperature: true,
      sortDirection_Temperature: 'asc',
      filter_Temperature: null,
      filterOn_Temperature: [],
      currentPage_Battery: 1,
      sortBy_Battery: '',
      sortDesc_Battery: false,
      sortDirection_Battery: 'asc',
      filter_Battery: null,
      filterOn_Battery: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      statusFilter_Resolution: 'five_minutes',
      statusFilter_Temperature: 'A',
      statusFilter_Battery: 'AC',
      status: [{
        AC: 'Active', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        AC: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      statusOptions: [
        { title: 'Realtime', value: 'A' },
        { title: 'History', value: 'M' },
      ],
      trendInterval: null,
    }
  },
  computed: {
    ...mapState({
      DeviceOptions: state => state.site.optionsdevice,
      LocationOptions: state => state.location.options,
      trend: state => state.temperature.trend,
      fields_Temperature: state => state.temperature.fields_Temperature,
      totalRows: state => state.historicalDevice.totalRows,
      historical_temperature: state => state.temperature.historical_temperature,
      pageOptions_Temperature: state => state.temperature.pageOptions_Temperature,
      items: state => state.device.items,
      historical_items: state => state.historicalDevice.items,
      table_items: state => state.historicalDevice.tableItems,
      fields_historical: state => state.historicalDevice.fields,
    }),
    series() {
      const { value } = this.realtime_sparing
      if (value === undefined) return ['NaN']
      return [value]
    },
    sortOptions_Temperature() {
      // Create an options list from our fields
      return this.fields_Temperature
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    sortOptions_Battery() {
      // Create an options list from our fields
      return this.fields_historical
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat() {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    },
  },
  mounted() {
    // Set the initial number of items
    this.$store.state.totalRows = this.historical_temperature.length
    this.$store.state.totalRows_Battery = this.historical_items.length
  },
  created() {
    if (this.isDark === true) {
      this.goalOverviewRadialBarTemperature.plotOptions.radialBar.dataLabels.value.color = '#ffffff'
    }
    this.$store.dispatch('device/getFilteredStatus')
  },
  beforeDestroy() {
    if (this.trendInterval) clearInterval(this.trendInterval)
  },
  methods: {
    valueToPercent(val, minValue, maxValue) {
      // return (val * 100)
      const percentage = ((val - minValue) * 100) / (maxValue - minValue)
      return percentage.toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 })
      // return ((val - minValue) * 100) / (maxValue - minValue)
      // return ((val - this.realtime_sparing.value_min) * 100 ) / (this.realtime_sparing.value_max - this.realtime_sparing.value_min)
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered_Temperature(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onFiltered_Battery(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows_Battery = filteredItems.length
      this.currentPage_Battery = 1
    },
    advanceSearch(val) {
      this.searchTerm = val
    },
    moment(date) {
      return moment(date)
    },
    async setDevice() {
      if (this.statusFilter_Temperature === 'A') {
        const jakartaDate = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Jakarta',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).split('/')

        const currentDate = `${jakartaDate[2]}-${jakartaDate[0]}-${jakartaDate[1]}`
        await this.$store.dispatch('historicalDevice/getByRangeDate', {
          deviceId: this.select_device.id,
          startDate: currentDate,
          endDate: currentDate,
          page: this.currentPage,
          perPage: this.perPage,
          sort: this.sortDesc_Temperature ? 'DESC' : 'ASC',
          resolution: 'five_minutes',
          type: 'table',
        })
        this.trendInterval = setInterval(() => {
          this.$store.dispatch('temperature/getAllSparing', this.params).then(resp => {
            this.injectData(resp)
          })
        }, 60000)
      } else {
        await this.$store.dispatch('historicalDevice/getByRangeDate', {
          deviceId: this.select_device.id,
          startDate: this.date_start,
          endDate: this.date_finish,
          page: this.currentPage,
          perPage: this.perPage,
          resolution: this.statusFilter_Resolution,
          sort: this.sortDesc_Temperature ? 'DESC' : 'ASC',
          type: 'table',
        })
      }
    },
    async filterDevice() {
      this.currentPage = 1
      if (this.statusFilter_Temperature === 'A') {
        const jakartaDate = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Jakarta',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).split('/')

        const currentDate = `${jakartaDate[2]}-${jakartaDate[0]}-${jakartaDate[1]}`
        await this.$store.dispatch('historicalDevice/getByRangeDate', {
          deviceId: this.select_device.id,
          // startDate: currentDate,
          // endDate: currentDate,
          // resolution: 'five_minutes',
          limit: 1,
          type: 'all',
        })
      } else {
        await this.$store.dispatch('historicalDevice/getByRangeDate', {
          deviceId: this.select_device.id,
          // startDate: this.date_start,
          // endDate: this.date_finish,
          // resolution: this.statusFilter_Resolution,
          limit: 0,
          type: 'gauge',
        })
        await this.$store.dispatch('historicalDevice/getByRangeDate', {
          deviceId: this.select_device.id,
          startDate: this.date_start,
          endDate: this.date_finish,
          limit: 1,
          resolution: this.statusFilter_Resolution,
          type: 'table',
        })
      }
      this.realtime_sparing.value = Number(this.historical_items.reduce((sum, item) => sum + item.curr_temp, 0) / this.historical_items.length).toFixed(2)
      this.realtime_sparing.value_max = this.historical_items[0]?.limit_max
      this.realtime_sparing.value_min = this.historical_items[0]?.limit_min
      if (this.historical_items.length) {
        const temperature_value = this.historical_items.map(item => parseFloat(item.curr_temp) || 0)
        const temperature_time = this.historical_items.map(item => ({ ...item, actual_date: this.$options.filters.formatDate(item.actual_date) }))
        const temperatureChart = { ...this.lineChartSimpleTemperature }
        temperatureChart.series[0] = {
          name: 'Sparing',
          data: temperature_value,
        }
        this.lineChartSimpleTemperature.chartOptions = {
          xaxis: {
            categories: temperature_time,
            labels: {
              rotate: 0,
              tickAmount: 10, // Control number of ticks shown
              tickPlacement: 'on',
              hideOverlappingLabels: true,
              style: {
                colors: this.isDark ? '#ffffff' : '#000000',
              },
            },
          },
          yaxis: {
            min: this.realtime_sparing.value_min - 10,
            max: this.realtime_sparing.value_max + 10,
            labels: {
              style: {
                colors: this.isDark ? '#ffffff' : '#000000',
              },
            },
          },
          tooltip: {
            x: {
              show: true,
              formatter(value) {
                const val = temperature_time[value - 1]
                return val.actual_date
              },
            },
          },
        }
        temperatureChart.chartOptions.annotations = {
          yaxis: [{
            y: this.realtime_sparing.value_max,
            borderColor: '#EF0E31',
            borderWidth: 3,
            strokeDashArray: 3,
            label: {
              borderColor: '#EF0E31',
              style: {
                color: '#fff',
                background: '#EF0E31',
              },
              text: 'MAX VALUE',
            },
          },
          {
            y: this.realtime_sparing.value_min,
            borderColor: '#EF0E31',
            borderWidth: 3,
            strokeDashArray: 3,
            label: {
              borderColor: '#EF0E31',
              style: {
                color: '#fff',
                background: '#EF0E31',
              },
              text: 'MIN VALUE',
            },
          }],
        }
        this.lineChartSimpleTemperature = temperatureChart
      }
    },
    resetLineChart() {
      this.lineChartSimpleTemperature = {
        series: [
          {
            name: 'Sparing',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              areas: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
          },
        },
      }
    },
    exportExcelTemperature(evt) {
      const jsons = []
      for (let y = 0; y < this.historical_items.length; y++) {
        jsons[y] = {
          Id: this.historical_items[y].id,
          'Serial Number': this.historical_items[y].serial_number,
          'Current Temperature': this.historical_items[y].curr_temp,
          'Actual Date': this.dateFormat(this.historical_items[y].actual_date),
          'Status Device': this.historical_items[y].status_device ? 'Online' : 'Offline',
          Signal: this.historical_items[y].signal,
          Battery: this.historical_items[y].battery,
          Power: this.historical_items[y].power ? 'Active' : 'Inactive',
        }
      }

      const data_json = XLSX.utils.json_to_sheet(jsons)

      // Set column widths
      data_json['!cols'] = [
        { wch: 10 },
        { wch: 25 },
        { wch: 20 },
        { wch: 25 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
      ]

      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data_json, 'data')
      XLSX.writeFile(wb, `Sinar_Meadow_Trend_data_${moment(this.date_start).format('DD-MM-YYYY')}_${moment(this.date_finish).format('DD-MM-YYYY')}.xlsx`)
    },
    exportExcelBattery(evt) {
      const jsons = []
      for (let x = 0; x < this.historical_items.length; x++) {
        jsons[x] = {
          datetime: moment(String(this.historical_items[x].datetime)).format('DD-MM-YYYY HH:mm:ss'),
          value: this.historical_items[x].value + this.historical_items[x].value_default_unit,
        }
      }
      const data_json = XLSX.utils.json_to_sheet(jsons)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data_json, 'data')
      XLSX.writeFile(wb, `Battery_data_${moment(this.date_start).format('DD-MM-YYYY')}_${moment(this.date_finish).format('DD-MM-YYYY')}.xlsx`)
    },
  },
  directives: {
    Ripple,
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
